import { useQueries } from "@tanstack/react-query";
import { getAppConfig, getGamesParticipated, getSchedule } from "../../../api";

export function useGameListQueries() {
  return useQueries({
    queries: [
      {
        queryKey: ["config"],
        queryFn: async () => {
          return getAppConfig();
        },
      },
      {
        queryKey: ["schedule"],
        queryFn: async () => {
          return getSchedule();
        },
      },
      {
        queryKey: ["gamesParticipated"],
        queryFn: async () => {
          return getGamesParticipated();
        },
      },
    ],
  });
}
